import { type FC } from 'react'

import { IconEyeClose, IconEyeOpen } from '@redteclab/icons'

type LoginRegistrationUserLoginShowPasswordProps = {
  showPassword: boolean
  toggleShowPassword: () => void
}

export const LoginRegistrationUserLoginShowPassword: FC<
  LoginRegistrationUserLoginShowPasswordProps
> = ({ showPassword, toggleShowPassword }) => {
  const Icon = showPassword ? IconEyeClose : IconEyeOpen

  return (
    <button onClick={toggleShowPassword} type="button">
      <Icon className="size-8 fill-dark-primary-max" />
    </button>
  )
}
